import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { BussinessYelp } from 'src/app/pages/integration/integration-setup/integration-setup';
import { ApiService } from "./../../services/api";

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {
  token = this.cookieService.get("token");
  storeId = this.cookieService.get("storeId");
  merchantId = this.cookieService.get("merchantId");

  GLOBALURL = this.ApiService.getBaseURL();
  loyaltyUrl = "https://loyaltyapi.eatos.net";

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private ApiService: ApiService
  ) { }

  addIntegration(newIntegrationPayload: any): Observable<any> {
    return this.http.post<any>(this.GLOBALURL + `/store/integrations?storeId=${this.storeId}&integration=1`, newIntegrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  // New MarketMAn API
  saveMarketMAn(newIntegrationPayload: any): Observable<any> {
    return this.http.post<any>(this.GLOBALURL + '/marketman/accounts', newIntegrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      // params: new HttpParams()
      //   .set('apiKey', newIntegrationPayload.apiKey)
      //   .set('apiPassword', newIntegrationPayload.apiPassword)
    })
  }

  VoucherifyValidateIntegration(integrationPayload: any): Observable<any> {
    return this.http.post<any>(this.GLOBALURL + `/voucherify/integrate`, integrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  updateDoordashIntegration(integrationPayload: any): Observable<any> {
    return this.http.post<any>(this.GLOBALURL + `/doordash/updateBizAndStore`, integrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  addDoordashIntegration(integrationPayload: any): Observable<any> {
    return this.http.post<any>(this.GLOBALURL + `/doordash/createBizAndStore`, integrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  getAllIntegration(storeId:any): Observable<any> {
    return this.http.get<any>(this.GLOBALURL +  `/store?storeId=${storeId}&integration=1`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  getUpcomingIntegrations(filteredCategory: string): Observable<any> {
    if(filteredCategory === 'All') {
      return this.http.get<any>(this.GLOBALURL +  `/integrations`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
    } else {
      return this.http.get<any>(this.GLOBALURL +  `/integrations`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: new HttpParams()
          .set('category', filteredCategory)
      })
    }
  }

  getIntegrationByName(name: string,storeId?:string) {
    return this.http.get<any>(this.GLOBALURL +  `/integrations`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      params: new HttpParams()
        .set('integrationName', name)
        .set('storeId', storeId)
    })
  }

  updateIntegration(updateIntegrationPayload: any): Observable<any>{
    return this.http.put<any>(this.GLOBALURL + '/store/integrations', updateIntegrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

sync7shifts(updateIntegrationPayload: any): Observable<any>{
    return this.http.post<any>(this.GLOBALURL + '/7shift/sync', updateIntegrationPayload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      params: new HttpParams()
      .set('storeId',updateIntegrationPayload.storeId )
      .set('merchantId',updateIntegrationPayload.merchantId )
    })
  }

  installAdyen(payload: any): Observable<any>{
    return this.http.post<any>(this.GLOBALURL + '/adyen/onboarding', payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      })
    })
  }


  installLoyalty(payload: any): Observable<any> {
    return this.http.post<any>(this.GLOBALURL + '/loyaltyOs/integrate', payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // Authorization: this.cookieService.get("token"),
      })
    });
  }

  getNewOnboardingLink(payload: any): Observable<any>{
    console.log("GETTING NEW LINK");
    return this.http.post<any>(this.GLOBALURL + '/adyen/onboarding/link', payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      })
    })
  }

  deleteIntegration(payload: any): Observable<any> {
    return this.http.delete<any>(`${this.GLOBALURL}/store/integrations/`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      body: payload
    })
  }

  startPoyntIntegration(payload: any): Observable<any> {
    return this.http.post<any>(`${this.GLOBALURL}/poynt/auth`, payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  startYelpIntegration(): Observable<{success: number, response: BussinessYelp[], message?: string}> {
    return this.http.get<{success: number, response: BussinessYelp[], message?: string}>(`${this.GLOBALURL}/yelp/business?storeId=${this.storeId}&auto=true`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  addYelpIntegration(payload: any): Observable<any> {
    return this.http.post<any>(`${this.GLOBALURL}/store/integrations`, payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  syncMarketMan(payload: any): Observable<any> {
    return this.http.post<any>(`${this.GLOBALURL}/marketman/setup`, payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    })
  }

  // installAdyen(payload: any): Observable<any>{
  //   return this.http.post<any>(this.GLOBALURL + '/adyen/onboarding', payload, {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //       Authorization: this.cookieService.get("token"),
  //     })
  //   })
  // }
}
